// extracted by mini-css-extract-plugin
export default {"content":"routes_content__R+cup","fullHeight":"routes_fullHeight__AuwR5"};